var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { isWebPSupported } from '@rendering/fusion-react';
import { load } from '@rendering/flash';
import { memoizePromiseFn } from '../utils/memoizePromiseFn';
function getSearchParam(params, target) {
    var _a;
    return (_a = params.get(target)) !== null && _a !== void 0 ? _a : params.get(target.toLowerCase());
}
function parseScene(url) {
    var _a;
    const params = new URLSearchParams(new URL(url).search);
    return (_a = getSearchParam(params, 'scene')) !== null && _a !== void 0 ? _a : url;
}
export const memoizedLoadCompiledScene = memoizePromiseFn(({ sceneUrl }) => __awaiter(void 0, void 0, void 0, function* () {
    const webPSupported = yield isWebPSupported();
    const imageFormat = webPSupported ? 'webp' : 'png';
    return yield load({ sceneUrl, settings: { environment: 'prod', imageFormat, imageQuality: 85 } });
}));
export const useCompiledScene = ({ scene }) => {
    const [compiledSceneState, setCompiledSceneState] = useState();
    useEffect(() => {
        let ignore = false;
        const sceneUrl = parseScene(scene);
        memoizedLoadCompiledScene({ sceneUrl })
            .then((result) => {
            if (!ignore) {
                setCompiledSceneState({ source: scene, compiledScene: result, needsServerFallback: false });
            }
        })
            .catch(() => {
            if (!ignore) {
                setCompiledSceneState({ source: scene, needsServerFallback: true });
            }
        });
        return () => {
            ignore = true;
        };
    }, [scene]);
    if (scene === (compiledSceneState === null || compiledSceneState === void 0 ? void 0 : compiledSceneState.source)) {
        return { compiledScene: compiledSceneState.compiledScene, needsServerFallback: compiledSceneState.needsServerFallback };
    }
    return { compiledScene: undefined, needsServerFallback: false };
};
//# sourceMappingURL=useCompiledScene.js.map